<template>
	<div class="Das__System">
		<div class="container">
			<h1>{{ $t('navigationDasSystem.wasIstDasSystem.title') }}</h1>
			<div class="row align-items-center">
				<div class="py-5 col-9">
					<div class="mb-3">
						{{ $t('navigationDasSystem.wasIstDasSystem.text.absatz1') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDasSystem.wasIstDasSystem.text.absatz2') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationDasSystem.wasIstDasSystem.text.absatz3') }}
					</div>
				</div>
			</div>
		</div>
		<div ref="survivingRealShitRef" class="container-fluid">
			<div class="container py-5">
				<h4 class="">
					{{ $t('navigationDasSystem.survivingTheRealShit.title') }}
				</h4>
				<div class="row align-items-center d-flex">
					<div class="col-9">
						<div class="mb-3">
							{{ $t('navigationDasSystem.survivingTheRealShit.text.absatz1') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationDasSystem.survivingTheRealShit.text.absatz2') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationDasSystem.survivingTheRealShit.text.absatz3') }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container-fluid">
			<div class="container py-5" ref="systemConclusionRef">
				<h4>
					{{ $t('navigationDasSystem.strategieMitModernsterEffizienz.title') }}
				</h4>
				<div class="row align-items-center d-flex">
					<div class="col-9">
						<div class="mb-3">
							{{
								$t(
									'navigationDasSystem.strategieMitModernsterEffizienz.text.absatz1'
								)
							}}
						</div>
						<div class="mb-3">
							{{
								$t(
									'navigationDasSystem.strategieMitModernsterEffizienz.text.absatz2'
								)
							}}
						</div>
						<div class="mb-3">
							{{
								$t(
									'navigationDasSystem.strategieMitModernsterEffizienz.text.absatz3'
								)
							}}
						</div>
						<div class="mb-5">
							{{
								$t(
									'navigationDasSystem.strategieMitModernsterEffizienz.text.absatz4'
								)
							}}
						</div>
						<div class="Zitat mb-3">
							{{
								$t(
									'navigationDasSystem.strategieMitModernsterEffizienz.text.absatz5'
								)
							}}
						</div>
						<div class="system-action-button">
							<yellow-button
								:title="$t('navigationDasSystem.buttons.button1')"
								pathName="Aufbau"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import YellowButton from '@/components/YellowButton.vue'

export default {
	name: 'DasSystem',
	components: {
		YellowButton
	},
	i18n: {
		messages: {
			de: require('@/i18n/de/de_das-system.json'),
			en: require('@/i18n/en/eng_das-system.json')
		}
	}
}
</script>
<style lang="stylus" scoped>
.system-action-button {
	display: flex;
	justify-content: center;
	margin-top: 6vh;
}
</style>
